import React from 'react';

import { IconProps } from './types';

const AmountBag: React.FC<IconProps> = props => {
  const { width = '58', height = '68', opacity = '1', fillColor = 'var(--green-base)' } = props;
  return (
    <svg width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity={opacity}>
        <circle cx="34" cy="42.501" fill="#fff" r="22.667" />
        <path fill={fillColor} d="M21.696 19.877h27.227v39.932H21.696z" />
        <path
          d="M47.393 14.527a.97.97 0 0 1-.583-.777 1.214 1.214 0 0 1 0-1.02l3.157-4.08c.1-.135.181-.282.243-.438a5.635 5.635 0 0 0-.097-5.634A5.489 5.489 0 0 0 45.256.004H24.905a5.489 5.489 0 0 0-4.615 2.574A5.633 5.633 0 0 0 20 8.115a1.997 1.997 0 0 0 0 .437l3.157 4.08a1.214 1.214 0 0 1 0 1.02.972.972 0 0 1-.146.875C9.8 22.152 3.63 32.304 3.63 46.147s11.512 21.808 31.572 21.808 31.571-7.917 31.571-21.76c0-13.843-6.168-24.043-19.38-31.668ZM36.125 37.258c3.351 1.457 7.577 3.254 7.577 7.626 0 4.371-2.623 6.071-4.857 6.411a1.165 1.165 0 0 0-1.069 1.215v2.768a2.429 2.429 0 0 1-4.857 0v-2.671a1.214 1.214 0 0 0-1.214-1.215h-2.429a2.623 2.623 0 0 1 0-5.197h8.451a1.215 1.215 0 0 0 1.118-1.263c0-.825-3.06-2.137-4.566-2.768-3.352-1.506-7.577-3.352-7.577-7.675a6.217 6.217 0 0 1 5.148-6.265 1.263 1.263 0 0 0 .923-1.215v-2.768a2.429 2.429 0 0 1 4.857 0v2.72a1.215 1.215 0 0 0 1.215 1.214h2.428a2.623 2.623 0 0 1 0 5.197h-7.286c-.388 0-2.428 0-2.428 1.312 0 1.311 3.06 1.943 4.566 2.574Z"
          fill={fillColor}
        />
        <g
          clipPath="url(#a)"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M42.463 29.725H28.716h3.749c1.326 0 2.597.516 3.535 1.437a4.86 4.86 0 0 1 1.464 3.469A4.86 4.86 0 0 1 36 38.1a5.047 5.047 0 0 1-3.535 1.437h-3.75l7.5 7.359M28.716 34.63h13.747" />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="translate(19.966 23.596)" d="M0 0h29.993v29.436H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AmountBag;
